import { FormControl, FormGroup } from '@angular/forms';
import { UserPermissions } from '@shared-libs/enums';
import { IFormGroup } from '@shared-libs/interfaces';
import { IUser } from '@shared-models/user.model';

export interface IUserForm {
	id: string;
	UserPermissionGroupId: string;
	permissions: { [key in UserPermissions]: { key: UserPermissions; value: boolean } };
}

export class UserFormFactory {
	public static create(user?: Partial<IUser>): IFormGroup<IUserForm> {
		const form = new FormGroup({
			id: new FormControl(user?.id),
			UserPermissionGroupId: new FormControl(user?.UserPermissionGroupId),
			permissions: new FormControl(
				getFormPermissions(!user || !user?.UserPermissionGroupId, user?.permissions ?? [])
			),
		}) as IFormGroup;

		form.get('UserPermissionGroupId').valueChanges.subscribe((value) => {
			if (value !== null) {
				form.get('permissions').setValue(getFormPermissions(false, user?.permissions ?? []));
			}
		});

		return form;
	}

	public static getValue(form: IFormGroup<IUserForm>): Pick<IUser, 'UserPermissionGroupId' | 'permissions'> {
		return {
			UserPermissionGroupId: form.value.UserPermissionGroupId,
			permissions: Object.keys(form.value.permissions).filter(
				(permission) => form.value.permissions[permission].value === true
			) as UserPermissions[],
		};
	}
}

export const getFormPermissions = (useValue: boolean, userPermissions: Array<UserPermissions>) =>
	Object.fromEntries(
		Object.values(UserPermissions).map((permission) => [
			permission,
			{
				key: permission,
				value: !useValue
					? false
					: userPermissions.findIndex((userPermission) => userPermission === permission) !== -1,
			},
		])
	);
